import { on } from 'delegated-events';

/*!
 * Serialize all form data into a query string
 * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Node}   form The form to serialize
 * @return {String}      The serialized form data
 */
// eslint-disable-next-line func-names,@typescript-eslint/ban-ts-comment
// @ts-ignore
// eslint-disable-next-line func-names
const serialize = function (form) {
  // Setup our serialized data
  const serialized = [];

  if (form) {
    // Loop through each field in the form
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < form.elements.length; i++) {
      const field = form.elements[i];

      // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
      if (
        !field.name ||
        field.disabled ||
        field.type === 'file' ||
        field.type === 'reset' ||
        field.type === 'button'
      )
        // eslint-disable-next-line no-continue
        continue;

      // If a multi-select, get all selections
      if (field.type === 'select-multiple') {
        // eslint-disable-next-line no-plusplus
        for (let n = 0; n < field.options.length; n++) {
          // eslint-disable-next-line no-continue
          if (!field.options[n].selected) continue;
          serialized.push(
            `${encodeURIComponent(field.name)}=${encodeURIComponent(
              field.options[n].value,
            )}`,
          );
        }
      }

      // Convert field data to a query string
      else if (
        (field.type !== 'checkbox' && field.type !== 'radio') ||
        field.checked
      ) {
        serialized.push(
          `${encodeURIComponent(field.name)}=${encodeURIComponent(
            field.value,
          )}`,
        );
      }
    }
  }
  return serialized.join('&');
};

function addWindowObject() {
  const form = document.querySelector('#elc-cookie-consent-form');

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  if (form && typeof form.dataset.show !== 'undefined') {
    const xhr = new XMLHttpRequest();
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    xhr.open('GET', form.dataset.show);
    xhr.send();

    // eslint-disable-next-line func-names
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status !== 200) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          window.ccc = {};
        } else if (xhr.response === 'null') {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          window.ccc = {};
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
        } else window.ccc = JSON.parse(xhr.response);
      }
    };
  }
}

on('click', '#elc-accept-technical-link', (event) => {
  event.preventDefault();

  const checkboxStatistics = document.getElementById(
    'elc-cookie-consent__checkbox-2',
  );

  if (checkboxStatistics) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    checkboxStatistics.checked = false;
  }

  const form = document.querySelector('#elc-cookie-consent-form');
  const data = serialize(form);
  const cookieConsent = document.getElementById('elc-cookie-consent');

  if (cookieConsent) {
    cookieConsent.classList.toggle('elc-hidden');
  }

  const cookieTab = document.getElementById('elc-cookie-tab');
  if (typeof cookieTab !== 'undefined' && cookieTab !== null) {
    cookieTab.classList.toggle('elc-hidden');
  }

  if (form) {
    const xhr = new XMLHttpRequest();

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    xhr.open('POST', form.dataset.url);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.send(data);

    // eslint-disable-next-line func-names
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        addWindowObject();
        // eslint-disable-next-line no-console
        if (xhr.status !== 200) console.log(`Error: ${xhr.status}`);
        else if (
          form.hasAttribute('data-refresh') &&
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          form.dataset.refresh === 'true' &&
          form.hasAttribute('data-refreshtime')
        ) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          refresh(form.dataset.refreshtime);
        }
      }
    };
  }
});

function toggleHide() {
  const acceptAll = document.getElementById('elc-accept-all-link');
  const acceptTechnical = document.getElementById('elc-accept-technical-link');
  if (acceptAll) {
    acceptAll.classList.toggle('hidden');
  }

  if (acceptTechnical) {
    acceptTechnical.classList.toggle('hidden');
  }
}

const detailLink = document.getElementById('elc-detail-link');
if (detailLink !== null) {
  if (detailLink.addEventListener) {
    detailLink.addEventListener('click', toggleHide);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
  } else if (detailLink.attachEvent) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    detailLink.attachEvent('onclick', toggleHide);
  }
}

const hideDetailLink = document.getElementById('elc-hide-detail-link');
if (hideDetailLink !== null) {
  if (hideDetailLink.addEventListener) {
    hideDetailLink.addEventListener('click', toggleHide);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
  } else if (hideDetailLink.attachEvent) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    hideDetailLink.attachEvent('onclick', toggleHide);
  }
}

const tabLink = document.getElementById('elc-tab-link');
if (tabLink !== null) {
  if (tabLink.addEventListener) {
    tabLink.addEventListener('click', toggleHide);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
  } else if (tabLink.attachEvent) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    tabLink.attachEvent('onclick', toggleHide);
  }
}
